import React from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import RadioGroup from '../components/RadioGroup';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import { click_next_step5 } from '../techspec';

import { delivery } from '../data';
import useStore from '../store';

const Delivery = props => {
  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const [{ mostrarReferidos }, setStore] = useStore();

  const onSubmit = data => {
    click_next_step5();

    action(data);

    if (data.delivery === 'domicilio') {
      if (mostrarReferidos) {
        props.history.push({ pathname: '/8', state: 'domicilio' });
      } else {
        props.history.push({ pathname: '/9', state: 'domicilio' });
      }
    } else {
      props.history.push('/6');
    }
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>¿Cómo querés recibir tu tarjeta?</Title>

        <RadioGroup
          name="delivery"
          variant="icon"
          options={delivery}
          register={register({ required: 'Debe seleccionar una opción.' })}
          error={errors.delivery}
          defaultChecked={state?.data?.delivery}
        />
      </div>

      <div className="form-actions">
        <Button block type="submit" id="next-button-step-5">
          Siguiente
        </Button>

        <BackButton />
      </div>
    </StackForm>
  );
};

export default withRouter(Delivery);
